// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jgqr","content":"styles_content__2ocwA","row":"styles_row__1d_3x","footer":"styles_footer__3ftsK","phraseLength":"styles_phraseLength__w3uoV"};